import { useAtom } from '@reatom/npm-react'
import { memo, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { NumericFormat } from '@blade/std-lib'
import { FlashTextContentDistinct } from '@root/features/flash/flash-text-content-distinct'
import { InsiderIcon } from '@root/shared/ui-kit'

import { PairStatsPanelItem } from './pair-stats-panel-row-item'

import type { PairModel } from '@root/entities/pair'

type Props = {
  pair: PairModel
}

export const PairStatsPanelInsiders: React.FC<Props> = memo(({ pair }) => {
  const { t } = useTranslation()
  const [insiders] = useAtom(pair.insiders)

  const percent = insiders.holding
  const formatted = useMemo(
    () => NumericFormat.formatPreset(percent, 'percents'),
    [percent],
  )

  return (
    <PairStatsPanelItem
      title={t('insiders')}
      intent="Safe"
      icon={InsiderIcon}
      tooltip={t('trading.audit.insider_holding_tooltip', {
        percentage: formatted,
      })}
      value={<FlashTextContentDistinct>{formatted}%</FlashTextContentDistinct>}
    />
  )
})
